import React, { useState } from "react";
import axios from "axios";
import SecurityHeaders from "../../context/SecurityHeaders";
import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

const UpdateBatches = () => {
   const dispatch = useDispatch()
  const [batch1, setBatch1] = useState(null);
  const [batch2, setBatch2] = useState(null);
  const [batch3, setBatch3] = useState(null);
  const [batch4, setBatch4] = useState(null);
  const [batch5, setBatch5] = useState(null);
  const [batch6, setBatch6] = useState(null);

  const params = useParams()
  const course_url = params.course_url
  const course_id = params.course_id
  const [seatsLeft, setSeatsLeft] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState(null);


 
  const handleSubmit = async () => {
    dispatch({ type: 'LOADING' });
  
    const data = new FormData();
    data.append("batch1_starts", batch1);
    data.append("batch2_starts", batch2);
    data.append("batch3_starts", batch3);
    data.append("batch4_starts", batch4);
    data.append("batch5_starts", batch5);
    data.append("batch6_starts", batch6);
    data.append("seats_left", seatsLeft);
    data.append("course_url", course_url);
    data.append("course_id", course_id);
  
    try {
      const res = await axios.post(
        "https://skillsuprise.com/course-batches.php",
        data,
        SecurityHeaders
      );
  
      if (res?.data?.status) {
        dispatch({ type: 'DONE_LOADING' });
        setResponseMessage({ type: "success", text: "Update successful!" });
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data?.error || 'Failed to update batches' 
        });
        setResponseMessage({
          type: "error",
          text: `Update failed: ${res.data?.error || 'Unknown error'}`,
        });
      }
    } catch (error) {
      dispatch({ 
        type: 'ERROR', 
        payload: error.message || 'An error occurred while updating batches' 
      });
      setResponseMessage({
        type: "error",
        text: "Something went wrong. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        style={{
    
          padding: "20px",
  
          borderRadius: "8px",
        }}
      >
        <h2>Update Course Batches</h2>
        <form>
          <div>
            <label className="mt-2 mb-0">BATCH 1</label>
            <input
              type="date"
              placeholder="batch date"
              value={batch1}
              onChange={(e) => setBatch1(e.target.value)}
              className="w-100 form-control"
            />
          </div>

          <div>
            <label className="mt-2 mb-0">BATCH 2</label>
            <input
              type="date"
              placeholder="batch date"
              value={batch2}
              onChange={(e) => setBatch2(e.target.value)}
              className="w-100 form-control"
            />
          </div>

          <div>
            <label className="mt-2 mb-0">BATCH 3</label>
            <input
              type="date"
              placeholder="batch date"
              value={batch3}
              onChange={(e) => setBatch3(e.target.value)}
              className="w-100 form-control"
            />
          </div>

          <div>
            <label className="mt-2 mb-0">BATCH 4</label>
            <input
              type="date"
              placeholder="batch date"
              value={batch4}
              onChange={(e) => setBatch4(e.target.value)}
              className="w-100 form-control"
            />
          </div>

          <div>
            <label className="mt-2 mb-0">BATCH 5</label>
            <input
              type="date"
              placeholder="batch date"
              value={batch5}
              onChange={(e) => setBatch5(e.target.value)}
              className="w-100 form-control"
            />
          </div>

          <div>
            <label className="mt-2 mb-0">BATCH 6</label>
            <input
              type="date"
              placeholder="batch date"
              value={batch6}
              onChange={(e) => setBatch6(e.target.value)}
              className="w-100 form-control"
            />
          </div>

          <div>
            <label className="mt-2 mb-0">SEATS LEFT</label>
            <input
              type="number"
              placeholder="seats left"
              value={seatsLeft}
              onChange={(e) => setSeatsLeft(e.target.value)}
              className="w-100 form-control"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            onSubmit={handleSubmit}
            style={{
              width: "100%",
              padding: "10px",
              backgroundColor: loading ? "#ccc" : "#4CAF50",
              color: "white",
              border: "none",
              borderRadius: "4px",
              cursor: loading ? "not-allowed" : "pointer",
              fontWeight: "bold",
              marginTop: "20px",
            }}
          >
            {loading ? "Updating..." : "Update"}
          </button>
        </form>

        {responseMessage && (
          <div
            style={{
              marginTop: "20px",
              padding: "10px",
              borderRadius: "4px",
              color: responseMessage.type === "success" ? "green" : "red",
              backgroundColor:
                responseMessage.type === "success" ? "#e6ffed" : "#ffe6e6",
            }}
          >
            {responseMessage.text}
          </div>
        )}
      </div>
    </>
  );
};

export default UpdateBatches;
